const Vue = require('vue')
const Picker = require('components/customer/Picker.vue')

Vue.component('customer-picker', Picker)



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/customer-picker.js